var map = {
	"./da": "4e44",
	"./da.js": "4e44",
	"./de": "872c",
	"./de.js": "872c",
	"./en": "c33a",
	"./en.js": "c33a"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dcd7";
module.exports = webpackAsyncContext;